import { useEffect } from "react";
import CanvasPart from "./Components/CanvasPart/CanvasPart";
import DesignPanel from "./Components/DesignPanel/DesignPanel";
import HomeContextProvider from "./Context/HomeContext";
import LoadingMain from "./Components/LoadingMain/LoadingMain";
import Chat from "./Components/Chat/Chat";
import { useState } from "react";
import AssetPreloader from "./AssetPreloader";

export default function HomePage() {
  const [generalHeight, setGeneralHeight] = useState("100vh");

  const updateHeight = () => {
    if (window.innerWidth < 992) {
      setGeneralHeight(window.innerHeight);
    } else {
      setGeneralHeight("100vh");
    }
  };

  async function getData() {
    const url = "/Json/dataClient.json";
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const json = await response.json();
      const fonts = json?.design?.text?.textFont;

      const generateFontFaces = (fontArray) => {
        return fontArray
          .map(
            (font) => `
          @font-face {
            font-family: '${font.name}';
            src: url(${font.url});
          }
        `
          )
          .join("");
      };

      const applyDynamicFonts = (fontArray) => {
        const style = document.createElement("style");
        style.innerHTML = generateFontFaces(fontArray);
        document.head.appendChild(style);
      };

      applyDynamicFonts(fonts);
    } catch (error) {
      console.error(error.message);
    }
  }

  useEffect(() => {
    getData();
    // const fonts = data?.design?.text?.textFont;

    // const generateFontFaces = (fontArray) => {
    //   return fontArray
    //     .map(
    //       (font) => `
    //       @font-face {
    //         font-family: '${font.name}';
    //         src: url(${font.url});
    //       }
    //     `
    //     )
    //     .join("");
    // };

    // const applyDynamicFonts = (fontArray) => {
    //   const style = document.createElement("style");
    //   style.innerHTML = generateFontFaces(fontArray);
    //   document.head.appendChild(style);
    // };

    // applyDynamicFonts(fonts);
  }, []);

  useEffect(() => {
    updateHeight();

    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  return (
    <>
      <main className="Home" style={{ height: generalHeight }}>
        <div className="Home-container ">
          <HomeContextProvider>
            <AssetPreloader>
              <section className="ShowPart ">
                <CanvasPart />
              </section>

              <section className="DesignPanel row">
                <DesignPanel />
              </section>
              <div className="Chat-max992">
                <Chat />
              </div>
              <LoadingMain />
            </AssetPreloader>
          </HomeContextProvider>
        </div>
      </main>
    </>
  );
}
